<ng-container *transloco="let t">
  <form
    [formGroup]="dynamicForm | bgoAsFormGroup"
    data-testid="dynamic-form-group"
    [class.space-y-2xl]="verticalSpacing === 'normal'"
    [class.space-y-xs]="verticalSpacing === 'small'"
  >
    @for (answerFormGroup of dynamicForm.answerFormGroups; track answerFormGroup) {
      <div>
        @if (answerFormGroup.question; as question) {
          <div [formGroup]="answerFormGroup | bgoAsFormGroup">
            @if (labelPosition === 'top') {
              <div [class.mb-md]="verticalSpacing === 'normal'" [class.mb-2xs]="verticalSpacing === 'small'">
                <label class="heading-md" [for]="question.id">
                  {{ question.label }}
                  @if (!question.required) {
                    <span class="font-normal text-grey-400">
                      {{ t('optionalLabel') }}
                    </span>
                  }
                </label>
              </div>
            }
            @switch (question.type) {
              @case ('OPEN_TEXT_FIELD') {
                <div>
                  <cft-form-field class="h-full" [attr.data-testid]="question.id">
                    @if (labelPosition === 'control') {
                      <label [for]="question.id">
                        {{ question.label }}
                      </label>
                    }
                    <textarea
                      [id]="question.id"
                      [formControl]="asSingleAnswerControl(answerFormGroup.controls)"
                    ></textarea>
                    <span class="error"><span *ngTemplateOutlet="error"></span></span>
                  </cft-form-field>
                </div>
              }
              @case ('SINGLE_SELECT_DROPDOWN') {
                <cft-form-field [attr.data-testid]="question.id">
                  <cft-select
                    [id]="question.id"
                    [formControl]="asSingleAnswerControl(answerFormGroup.controls)"
                    [items]="selectOptions(question.options)"
                    [label]="labelPosition === 'control' ? question.label : undefined"
                  ></cft-select>
                  <span class="error"><span *ngTemplateOutlet="error"></span></span>
                </cft-form-field>
              }
              @case ('MULTIPLE_SELECT_CHECKBOXES') {
                <ng-container *ngTemplateOutlet="multipleSelect"></ng-container>
              }
              @case ('MULTIPLE_SELECT_TILES') {
                <ng-container *ngTemplateOutlet="multipleSelect"></ng-container>
              }
              @case ('SINGLE_SELECT_RADIO') {
                <ng-container *ngTemplateOutlet="singleSelectRadio"></ng-container>
              }
              @case ('SINGLE_SELECT_TILES') {
                <ng-container *ngTemplateOutlet="singleSelectRadio"></ng-container>
              }
              @case ('STEPPER') {
                <cft-number-input
                  [attr.data-testid]="question.id"
                  [id]="question.id"
                  [formControl]="asSingleAnswerControl(answerFormGroup.controls)"
                  [min]="stepperOptions(question.options).min"
                  [max]="stepperOptions(question.options).max"
                  [step]="stepperOptions(question.options).step ?? 1"
                  class="mt-xs"
                >
                  <span content="error"><span *ngTemplateOutlet="error"></span></span>
                </cft-number-input>
              }
            }
            @if (answerFormGroup.additionalInformationRequired$ | async) {
              <cft-form-field class="h-full" [attr.data-testid]="question.id + '-additional-information'">
                <label [for]="question.id + '-additional-information'">
                  {{ t('offering.questions.additionalInformation.label') }}
                </label>
                <textarea
                  [id]="question.id + '-additional-information'"
                  [formControl]="answerFormGroup.controls.additionalInformation | bgoAsFormControl"
                >
                </textarea>
                <span class="error">{{ t('offering.questions.additionalInformation.error') }}</span>
              </cft-form-field>
            }
            <ng-template #singleSelectRadio>
              <ul [attr.data-testid]="question.id" class="space-y-sm">
                @for (opt of selectOptions(question.options); track opt) {
                  <li>
                    @if (answerFormGroup.controls['answer']) {
                      <cft-radio
                        [name]="question.id"
                        [formControl]="answerFormGroup.controls['answer']"
                        [value]="opt.key"
                      >
                        {{ opt.value }}
                      </cft-radio>
                    }
                  </li>
                }
                @if (
                  asSingleAnswerControl(answerFormGroup.controls).invalid &&
                  asSingleAnswerControl(answerFormGroup.controls).touched
                ) {
                  <li class="mt-xs error">
                    <span *ngTemplateOutlet="error"></span>
                  </li>
                }
              </ul>
            </ng-template>
            <ng-template #multipleSelect>
              <ul [attr.data-testid]="question.id" class="space-y-sm">
                @for (control of answerFormGroup.answerControls; track control; let i = $index) {
                  <li formArrayName="answers">
                    @if (question.options) {
                      <cft-checkbox [formControl]="control" [name]="question.options[i].key">
                        {{ question.options[i].value }}
                      </cft-checkbox>
                    }
                  </li>
                }
                @if (
                  asMultiAnswerControl(answerFormGroup.controls).invalid &&
                  asMultiAnswerControl(answerFormGroup.controls).touched
                ) {
                  <li class="mt-xs error">
                    <span *ngTemplateOutlet="error"></span>
                  </li>
                }
              </ul>
            </ng-template>
            <ng-template #error>
              @if (question.error) {
                <span>{{ question.error }}</span>
              } @else {
                {{
                  question.type === 'STEPPER'
                    ? t('dynamicFormErrorMessages.' + question.type, {
                        min: stepperOptions(question.options).min,
                        max: stepperOptions(question.options).max,
                      })
                    : t('dynamicFormErrorMessages.' + question.type)
                }}
              }
            </ng-template>
          </div>
        }
      </div>
    }
  </form>
</ng-container>
